import { HaptikInitconfig } from '../../models/haptik';
import { ConnectStore } from '../../stores/auth.store';

export class HaptikService {
  static initialise(config: HaptikInitconfig) {
    window.haptikInitSettings = config;
  }

  static loadHaptikScript() {
    console.log('Loading Haptick script');
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.async = true;
    script.src = 'https://toolassets.haptikapi.com/platform/javascript-xdk/production/loader.js';
    const x = document.getElementsByTagName('head')[0];
    x.appendChild(script);
  }

  static replaceSDK(config: HaptikInitconfig) {
    window.HaptikSDK.destroy();
    window.haptikInitSettings = config;
    window.HaptikSDK.init(config);
  }

  static waitForSDK() {
    return new Promise((resolve, reject) => {
      document.addEventListener(
        'haptik_sdk',
        () => {
          resolve('');
        },
        { once: true }
      );
    });
  }

  static showApp() {
    window.HaptikSDK.show();
  }

  static hideApp() {
    window.HaptikSDK.hide();
  }

  static signIn(connectUser: ConnectStore) {
    const custom_data = {
      country_code: connectUser.countryCode,
      connect_id: connectUser.connectId,
      customer_no: connectUser.customerNumber,
      authenticated: connectUser.authenticated,
      agreement_id: connectUser.agreementId,
    };

    window.HaptikSDK.signup(
      {
        auth_id: connectUser.customerNumber,
        auth_code: connectUser.id_token,
        email: connectUser.email,
        mobile_no: connectUser.mobileNumber,
        username: '',
        custom_data: custom_data,
      },
      function (success: boolean, error: string) {
        if (!success) {
          console.error('ERROR Signing Up with Haptick:', error);
        }
      }
    );
  }
}

export default HaptikService;
